import { userSecuritiesAccountsSlice } from '!core/redux';
import { appStore } from '!core/redux/app.store';
import { fundsServices } from '!views/Market/Funds/redux/funds.services';
import { otpService } from '»components/Auth';

import { trlInsertOrderServices } from '../trlInsertOrder.services';

const orderComissions = async ({
  clientId,
  cashAccount,
  securityExchange,
  securityType,
  symbol,
  orderQty,
  currency,
  price,
  stopPx,
  side,
}) => {
  const orderComissionsResp = await trlInsertOrderServices.orderComissions({
    clientId,
    cashAccount,
    securityExchange,
    securityType,
    symbol,
    orderQty,
    currency,
    price,
    stopPx,
    side,
  });

  return orderComissionsResp;
};

export const orderCalcComissions = async ({
  orderQty,
  price,
  stopPx,
  clientId,
  cashAccount,
  securityExchange,
  securityType,
  symbol,
  currency,
  side,
}) => {
  let comissions;
  let isValid = true;
  let reason;

  const comissionsResp = await orderComissions({
    clientId,
    cashAccount,
    securityExchange,
    securityType,
    symbol,
    orderQty,
    currency,
    price,
    stopPx,
    side,
  });

  if (comissionsResp.errors) {
    reason = comissionsResp.errors[0].detail;
    isValid = false;
  } else {
    comissions = comissionsResp;
  }

  return { isValid, comissions, reason };
};

export const insertOrder = async ({
  simulationId,
  operation = 'S',
  clientId,
  cashAccount,
  securityExchange,
  securityType,
  symbol,
  ordType,
  side,
  orderQty,
  currency,
  price,
  stopPx,
  timeInForce,
  expireTime,
  confirmSeq,
  isin,
  qtyType,
  settlLocation,
  isFunds,
}) => {
  let isValid = true;
  let reason;
  let order;

  let insertOrderResp = null;

  if (isFunds) {
    insertOrderResp = await fundsServices.fundSubmit({
      simulationId,
      operation,
      clientId,
      cashAccount,
      securityExchange,
      symbol,
      isin,
      currency,
      side,
      qtyType,
      orderQty,
      timeInForce,
      expireTime,
      settlLocation,
      confirmSeq,
    });
  } else {
    insertOrderResp = await trlInsertOrderServices.insertOrder({
      simulationId,
      operation,
      clientId,
      cashAccount,
      securityExchange,
      securityType,
      symbol,
      ordType,
      side,
      orderQty,
      currency,
      price,
      stopPx,
      timeInForce,
      expireTime,
      confirmSeq,
    });
  }

  if (insertOrderResp.errors) {
    reason = insertOrderResp.errors[0].detail;
    isValid = false;
  } else if (insertOrderResp[0].ordRejReason === 'C') {
    reason = insertOrderResp[0].text;
    isValid = false;
    order = insertOrderResp;
  } else {
    order = insertOrderResp;
    appStore.dispatch(
      userSecuritiesAccountsSlice.actions.userSecuritiesAccountsRequest(),
    );
  }
  return { isValid, order, reason };
};

export const replaceOrder = async ({
  simulationId,
  operation = 'S',
  clientId,
  ordBookKey,
  orderQty,
  ordType,
  price,
  stopPx,
  timeInForce,
  expireTime,
  confirmSeq,
}) => {
  let isValid = true;
  let reason;
  let order;

  const replaceOrderResp = await trlInsertOrderServices.replaceOrder({
    simulationId,
    operation,
    clientId,
    ordBookKey,
    orderQty,
    ordType,
    price,
    timeInForce,
    stopPx,
    expireTime,
    confirmSeq,
  });

  if (replaceOrderResp.errors) {
    reason = replaceOrderResp.errors[0].detail;
    isValid = false;
  } else if (replaceOrderResp[0].ordRejReason === 'C') {
    reason = replaceOrderResp[0].text;
    isValid = false;
    order = replaceOrderResp;
  } else {
    order = replaceOrderResp;
    appStore.dispatch(
      userSecuritiesAccountsSlice.actions.userSecuritiesAccountsRequest(),
    );
  }
  return { isValid, order, reason };
};

export const validateCode = async ({
  validationCode,
  setIsValidRequest,
  setInvalidRequestReason,
  handleSagaError,
}) => {
  const validationCodeResp = await otpService
    .validateOTPAuth({
      otp: validationCode,
    })
    .then((response) => {
      if (response[0].success === 'Y') return true;
      return false;
    })
    .catch((error) => {
      handleSagaError(error);
      setIsValidRequest(false);
      setInvalidRequestReason(error[0].detail);
      return false;
    });

  return validationCodeResp;
};
